<template>
  <el-button
    :type="type"
    :disabled="disabled"
    @click="handleClick"
    class="base-icon-button"
    :class="{ plain: plain }"
  >
    <div class="flex items-center gap-x-2">
      <component :is="icon" :color="iconColor" :size="iconSize" />
      {{ label }}
      <template v-if="appendIcon">
        <component :is="appendIcon" :color="iconColor" :size="iconSize" />
      </template>
    </div>
  </el-button>
</template>

<script>
import {
  BlueDot,
  CheckCircle,
  DeleteOutlined,
  Down,
  EditIcon,
  EmptyIcon,
  Export,
  ExportIcon,
  FilterActiveIcon,
  FilterIcon,
  GrayDot,
  GreenDot,
  HistoryIcon,
  ImportIcon,
  Picture,
  Plus,
  RedDot,
  ResetIcon,
  SearchIcon,
  User,
  UserAdd,
  AssignIcon,
  FilterWithDot,
  ResetPasswordIcon,
} from "src/components/icons";

export default {
  components: {
    ImportIcon,
    ExportIcon,
    SearchIcon,
    FilterIcon,
    FilterActiveIcon,
    HistoryIcon,
    GreenDot,
    EditIcon,
    RedDot,
    EmptyIcon,
    ResetIcon,
    BlueDot,
    GrayDot,
    Plus,
    UserAdd,
    DeleteOutlined,
    Export,
    CheckCircle,
    User,
    Picture,
    Down,
    AssignIcon,
    FilterWithDot,
    ResetPasswordIcon
  },
  props: [
    "label",
    "icon",
    "type",
    "to",
    "disabled",
    "iconSize",
    "plain",
    "appendIcon",
  ],
  computed: {
    iconColor() {
      if (!this.type) return "rgba(0, 0, 0, 0.85)";
      return "#fff";
    },
  },
  methods: {
    handleClick() {
      if (this.to) this.$router.push(this.to);
      this.$emit("click");
    },
  },
};
</script>

<style lang="scss"></style>



// WEBPACK FOOTER //
// BaseIconButton.vue?0e532254